import React from "react";

// El componente recibe una prop llamada onClick para manejar el evento de clic.
const ExportButton = ({ onClick, disabled  }) => {
  return (
    <button
      onClick={onClick} // Vinculamos la función onClick que se pasa como prop
      disabled={disabled}
      className={`flex justify-center space-x-2 border rounded-md text-[#76A140] px-4 py-2 text-[14px] font-itcmedium ${
        disabled ? "text-[#808080] " : "text-[#76A140] "}`}
    >
      <p>Exportar</p>
      <div className="flex">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.625 12.375C0.79076 12.375 0.949732 12.4408 1.06694 12.5581C1.18415 12.6753 1.25 12.8342 1.25 13V16.125C1.25 16.4565 1.3817 16.7745 1.61612 17.0089C1.85054 17.2433 2.16848 17.375 2.5 17.375H17.5C17.8315 17.375 18.1495 17.2433 18.3839 17.0089C18.6183 16.7745 18.75 16.4565 18.75 16.125V13C18.75 12.8342 18.8158 12.6753 18.9331 12.5581C19.0503 12.4408 19.2092 12.375 19.375 12.375C19.5408 12.375 19.6997 12.4408 19.8169 12.5581C19.9342 12.6753 20 12.8342 20 13V16.125C20 16.788 19.7366 17.4239 19.2678 17.8928C18.7989 18.3616 18.163 18.625 17.5 18.625H2.5C1.83696 18.625 1.20107 18.3616 0.732233 17.8928C0.263392 17.4239 0 16.788 0 16.125V13C0 12.8342 0.065848 12.6753 0.183058 12.5581C0.300269 12.4408 0.45924 12.375 0.625 12.375Z"
            fill={disabled ? "#808080" : "#76A140"}
          />
          <path
            d="M9.55731 14.8175C9.61537 14.8757 9.68434 14.9219 9.76027 14.9534C9.8362 14.9849 9.9176 15.0011 9.99981 15.0011C10.082 15.0011 10.1634 14.9849 10.2394 14.9534C10.3153 14.9219 10.3843 14.8757 10.4423 14.8175L14.1923 11.0675C14.3097 10.9501 14.3756 10.791 14.3756 10.625C14.3756 10.459 14.3097 10.2999 14.1923 10.1825C14.075 10.0651 13.9158 9.99921 13.7498 9.99921C13.5838 9.99921 13.4247 10.0651 13.3073 10.1825L10.6248 12.8663V1.875C10.6248 1.70924 10.559 1.55027 10.4418 1.43306C10.3245 1.31585 10.1656 1.25 9.99981 1.25C9.83405 1.25 9.67508 1.31585 9.55787 1.43306C9.44066 1.55027 9.37481 1.70924 9.37481 1.875V12.8663L6.69231 10.1825C6.57496 10.0651 6.41578 9.99921 6.24981 9.99921C6.08384 9.99921 5.92467 10.0651 5.80731 10.1825C5.68995 10.2999 5.62402 10.459 5.62402 10.625C5.62402 10.791 5.68995 10.9501 5.80731 11.0675L9.55731 14.8175Z"
            fill={disabled ? "#808080" : "#76A140"}
          />
        </svg>
      </div>
    </button>
  );
};

export default ExportButton;
